import { useMutation } from '@tanstack/react-query';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { BitbucketCreateInstallationRequest } from '../httpClients/RepositoryClient/api.schema';
import { MUTATION_KEYS } from './consts';

export const useBitbucketCreateInstallationMutation = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.BITBUCKET_CREATE_INSTALLATION],
    mutationFn: async (payload: BitbucketCreateInstallationRequest) =>
      RepositoryClient.bitbucketCreateInstallation(payload),
  });
